import React, { useState } from "react";

// ─────────────────────────────────────────────
//  THEME
//  Change colors and sizes here
// ─────────────────────────────────────────────

const THEME = {
  horizontalAxisColor: "#ff7066", // color of Operationeel ↔ Strategisch axis + labels
  verticalAxisColor: "#012f54", // color of Advanced ↔ Instap axis + labels
  cellDefault: "#def8ff", // cell background (default)
  cellHover: "#88e6ff", // cell background (hovered)
  cellEmpty: "#fff", // empty cell background
  textDefault: "#012f54", // cell text color (default)
  textHover: "#2a53d3", // cell text color (hovered)
  axisLineWidth: "3px", // thickness of the two axis lines
  cellSize: 110, // width & height of each cell in px
  fontSize: 12,
  fontFamily: "Arial",
  background: "#f0f4f8", // page background
};

// ─────────────────────────────────────────────
//  MATRIX DATA
//  Row 1 = top (Advanced), Row 6 = bottom (Instap)
//  Col 1 = left (Operationeel), Col 6 = right (Strategisch)
//
//  Each cell is one of:
//    null                              → empty
//    { title, url }                    → single training
//    { items: [{ title, url }, ...] }  → two trainings sharing a square
// ─────────────────────────────────────────────
const MATRIX = [
  // ── Row 1: Advanced ──────────────────────────────────────────────────────────
  [
    null,
    null,
    {
      title: "Vibe Coding: van Idee naar Live App",
      url: "https://www.beeckestijn.org/opleidingen/vibe-coding-van-idee-naar-live-app-training/",
    },
    {
      title: "Advanced AI in Business Analytics",
      url: "https://www.beeckestijn.org/opleidingen/advanced-ai-in-business-analytics-training/",
    },
    {
      title: "Next Leadership: Managen in het AI-tijdperk",
      url: "https://www.beeckestijn.org/opleidingen/next-leadership-managen-in-het-ai-tijdperk-masterclass/",
    },
    {
      title: "Digitale Innovatie, AI & Change",
      url: "https://www.beeckestijn.org/opleidingen/digitale-innovatie-ai-change-post-master/",
    },
  ],

  // ── Row 2 ─────────────────────────────────────────────────────────────────────
  [
    null,
    {
      title: "AI-Agents Bouwen met Effectieve Prompts",
      url: "https://www.beeckestijn.org/opleidingen/ai-agents-bouwen-met-effectieve-prompts-training/",
    },
    {
      items: [
        {
          title: "Advanced Videoproductie met AI",
          url: "https://www.beeckestijn.org/opleidingen/advanced-videoproductie-met-ai-training/",
        },
        {
          title: "AI Videocreatie met Midjourney",
          url: "https://www.beeckestijn.org/opleidingen/ai-videocreatie-met-midjourney-training/",
        },
      ],
    },
    {
      title: "Claude: Projects, Skills & Cowork",
      url: "https://www.beeckestijn.org/opleidingen/claude-projects-skills-cowork-training/",
    },
    {
      title: "Digital Marketing, Strategie, AI & Leiderschap",
      url: "https://www.beeckestijn.org/opleidingen/digital-marketing-strategie-ai-leiderschap-post-master/",
    },
    {
      title: "AI Adoptie, Cultuur & Governance",
      url: "https://www.beeckestijn.org/opleidingen/ai-adoptie-cultuur-governance-masterclass/",
    },
  ],

  // ── Row 3: Medior (above horizontal axis) ────────────────────────────────────
  [
    { 
      title: "Google Gemini", 
      url: "https://www.beeckestijn.org/opleidingen/google-gemini-training/"
    },
    {
      title: "Markt & Klantonderzoek met AI",
      url: "https://www.beeckestijn.org/opleidingen/markt-en-klantonderzoek-met-ai-training/",
    },
    {
      items: [
        {
          title: "Vibe Coding Introductie",
          url: "https://www.beeckestijn.org/opleidingen/vibe-coding-introductie-training/",
        },
        {
          title: "AI-Agents & Automations",
          url: "https://www.beeckestijn.org/opleidingen/ai-agents-automations-training/",
        },
      ],
    },
    {
      items: [
        { 
          title: "AI in Business", 
          url: "https://www.beeckestijn.org/opleidingen/ai-in-business-masterclass/"
        },
        {
          title: "Bouw jouw Digitale AI team",
          url: "https://www.beeckestijn.org/opleidingen/bouw-jouw-digitale-ai-team-training/",
        },
      ],
    },
    {
      title: "AI Business Professional",
      url: "https://www.beeckestijn.org/opleidingen/ai-business-professional-post-hbo/",
    },
    null,
  ],

  // ── Row 4: Tactisch (below horizontal axis) ───────────────────────────────────
  [
    {
      title: "Contentcreatie met Canva",
      url: "https://www.beeckestijn.org/opleidingen/contentcreatie-met-canva-training/",
    },
    { 
      title: "Van SEO naar GEO", 
      url: "https://www.beeckestijn.org/opleidingen/van-seo-naar-geo-training/"
    },
    {
      title: "AI in B2B Sales", 
      url: "https://www.beeckestijn.org/opleidingen/ai-in-b2b-sales-training/" 
    },
    {
      title: "AI voor Marketing",
      url: "https://www.beeckestijn.org/opleidingen/ai-voor-marketing-training/",
    },
    null,
    null,
  ],

  // ── Row 5 ─────────────────────────────────────────────────────────────────────
  [
    {
      title: "Copywriting met AI",
      url: "https://www.beeckestijn.org/opleidingen/copywriting-met-ai-training/",
    },
    {
      title: "Copilot voor Microsoft Office 365 & Agents",
      url: "https://www.beeckestijn.org/opleidingen/copilot-voor-microsoft-office-365-agents-training/",
    },
    {
      items: [
        {
          title: "AI voor Beeld- & Videocreatie",
          url: "https://www.beeckestijn.org/opleidingen/ai-voor-beeld-en-videocreatie-training/",
        },
        {
          title: "AI in Communicatie",
          url: "https://www.beeckestijn.org/opleidingen/ai-in-communicatie-training/",
        },
      ],
    },
    
    {
      title: "AI Powered Online Marketeer",
      url: "https://www.beeckestijn.org/opleidingen/ai-powered-online-marketeer-post-hbo/",
    },
    null,
    null,
  ],

  // ── Row 6: Instap ─────────────────────────────────────────────────────────────
  [
    {
      items: [
        {
          title: "AI Prompting & Tools",
          url: "https://www.beeckestijn.org/opleidingen/ai-prompting-tools-training/",
        },
        {
          title: "AI Geletterdheid & AI Act",
          url: "https://www.beeckestijn.org/opleidingen/ai-geletterdheid-ai-act-training/",
        },
      ],
    },
    {
      title: "Copilot Introductie",
      url: "https://www.beeckestijn.org/opleidingen/slimmer-werken-met-copilot-training/",
    },
    null,
    null,
    null,
    null,
  ],
];

// ─────────────────────────────────────────────
//  AXIS LABEL POSITIONS
//  horizontalAxisRow : the axis line sits between this row and the one above
//  verticalAxisCol   : the axis line sits between this column and the one to the left
//  mediorTactischCol : horizontal pixel position of the Medior/Tactisch labels
//                      (= verticalAxisCol * cellSize)
// ─────────────────────────────────────────────
const HORIZONTAL_AXIS_ROW = 3; // thick border on top of row 3 / bottom of row 2
const VERTICAL_AXIS_COL = 3; // thick border on left of col 3 / right of col 2
const LABEL_LEFT_PX = VERTICAL_AXIS_COL * 110; // auto-calculated from cellSize

// ─────────────────────────────────────────────
//  COMPONENT
// ─────────────────────────────────────────────
export default function AITrainingMatrix() {
  // clicked state: bool for single cells, bool[] for split cells
  const [clicked, setClicked] = useState(() =>
    MATRIX.map((row) =>
      row.map((cell) => {
        if (!cell) return false;
        if (cell.items) return cell.items.map(() => false);
        return false;
      })
    )
  );

  // hovered: { r, c } for single cells  |  { r, c, i } for split sub-items
  const [hovered, setHovered] = useState(null);

  // ── Helpers ──────────────────────────────────────────────────────────────────

  const isCellHovered = (r, c) =>
    hovered?.r === r && hovered?.c === c && hovered?.i === undefined;

  const isSubHovered = (r, c, i) =>
    hovered?.r === r && hovered?.c === c && hovered?.i === i;

  const cellBg = (r, c, hasContent) => {
    if (!hasContent) return THEME.cellEmpty;
    if (isCellHovered(r, c)) return THEME.cellHover;
    return THEME.cellDefault;
  };

  const subBg = (r, c, i) => {
    if (isSubHovered(r, c, i)) return THEME.cellHover;
    return THEME.cellDefault;
  };

  // ── Click handlers ────────────────────────────────────────────────────────────

  const onSingleClick = (r, c) => {
    const cell = MATRIX[r][c];
    if (!cell || cell.items) return;
    window.open(cell.url, "_blank", "noopener,noreferrer");
    setClicked((prev) => {
      const next = prev.map((row) => [...row]);
      next[r][c] = !next[r][c];
      return next;
    });
  };

  const onItemClick = (r, c, i) => {
    window.open(MATRIX[r][c].items[i].url, "_blank", "noopener,noreferrer");
    setClicked((prev) => {
      const next = prev.map((row) =>
        row.map((v) => (Array.isArray(v) ? [...v] : v))
      );
      next[r][c][i] = !next[r][c][i];
      return next;
    });
  };

  // ── Shared styles ─────────────────────────────────────────────────────────────

  const labelStyle = (bg, color = "#fff") => ({
    background: bg,
    color,
    fontSize: THEME.fontSize,
    fontFamily: THEME.fontFamily,
    padding: "4px 6px",
    whiteSpace: "nowrap",
  });

  const textStyle = (isHovered) => ({
    fontSize: THEME.fontSize,
    fontFamily: THEME.fontFamily,
    textAlign: "center",
    lineHeight: 1.35,
    color: isHovered ? THEME.textHover : THEME.textDefault,
    textDecoration: isHovered ? "underline" : "none",
  });

  const cellBorders = (r, c) => ({
    borderTop:
      r === HORIZONTAL_AXIS_ROW
        ? `${THEME.axisLineWidth} solid ${THEME.horizontalAxisColor}`
        : "1px solid #b0cce4",
    borderBottom:
      r === HORIZONTAL_AXIS_ROW - 1
        ? `${THEME.axisLineWidth} solid ${THEME.horizontalAxisColor}`
        : "1px solid #b0cce4",
    borderLeft:
      c === VERTICAL_AXIS_COL
        ? `${THEME.axisLineWidth} solid ${THEME.verticalAxisColor}`
        : "1px solid #b0cce4",
    borderRight:
      c === VERTICAL_AXIS_COL - 1
        ? `${THEME.axisLineWidth} solid ${THEME.verticalAxisColor}`
        : "1px solid #b0cce4",
  });

  // ── Render ────────────────────────────────────────────────────────────────────

  return (
    <div
      style={{
        fontFamily: "AG_Futura",
        minHeight: "100vh",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <div style={{ position: "relative" }}>
        {/* Grid + side labels */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>

          {/* Grid */}
          <div
            style={{ display: "flex", flexDirection: "column", flexShrink: 0 }}
          >
            {/* Top axis label */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 6,
              }}
            >
              <span style={labelStyle(THEME.verticalAxisColor)}>AI Advanced niveau</span>
            </div>

            {/* Rows */}
            {MATRIX.map((row, r) => (
              <React.Fragment key={r}>
                {/* Medior / Tactisch overlay — rendered between row 2 and row 3 */}
                {r === HORIZONTAL_AXIS_ROW && (
                  <div
                    style={{
                      position: "relative",
                      height: 0,
                      overflow: "visible",
                      zIndex: 10,
                      pointerEvents: "none",
                    }}
                  >
                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      right: 0,
                      top: 0,
                      transform: "translateY(-50%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      pointerEvents: "none",
                    }}
                  >
                    <span style={labelStyle(THEME.horizontalAxisColor, THEME.verticalAxisColor)}>
                      Operationeel
                    </span>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <span style={labelStyle(THEME.horizontalAxisColor, THEME.verticalAxisColor)}>Tactisch</span>
                      <span style={labelStyle(THEME.verticalAxisColor)}>AI Medior niveau</span>
                    </div>
                    <span style={labelStyle(THEME.horizontalAxisColor, THEME.verticalAxisColor)}>
                      Strategisch
                    </span>
                  </div>
                  </div>
                )}

                {/* Cells */}
                <div style={{ display: "flex" }}>
                  {row.map((cell, c) => {
                    const borders = cellBorders(r, c);
                    const baseStyle = {
                      width: THEME.cellSize,
                      height: THEME.cellSize,
                      flexShrink: 0,
                      boxSizing: "border-box",
                      ...borders,
                    };

                    // Split cell (two stacked sub-items)
                    if (cell?.items) {
                      return (
                        <div
                          key={c}
                          style={{
                            ...baseStyle,
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                          }}
                        >
                          {cell.items.map((item, i) => (
                            <div
                              key={i}
                              onClick={() => onItemClick(r, c, i)}
                              onMouseEnter={() => setHovered({ r, c, i })}
                              onMouseLeave={() => setHovered(null)}
                              style={{
                                flex: 1,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "4px 10px",
                                cursor: "pointer",
                                backgroundColor: subBg(r, c, i),

                                transition: "background-color 0.15s ease",
                              }}
                              title={`Open: ${item.title}`}
                            >
                              <span style={textStyle(isSubHovered(r, c, i))}>
                                {item.title}
                              </span>
                            </div>
                          ))}
                        </div>
                      );
                    }

                    // Single cell
                    const hasContent = !!cell;
                    return (
                      <div
                        key={c}
                        onClick={() => onSingleClick(r, c)}
                        onMouseEnter={() => hasContent && setHovered({ r, c })}
                        onMouseLeave={() => setHovered(null)}
                        style={{
                          ...baseStyle,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "8px 6px",
                          cursor: hasContent ? "pointer" : "default",
                          backgroundColor: cellBg(r, c, hasContent),
                          transform: clicked[r][c] ? "scale(0.97)" : "scale(1)",
                          transition:
                            "background-color 0.15s ease, transform 0.1s ease",
                        }}
                        title={hasContent ? `Open: ${cell.title}` : undefined}
                      >
                        {hasContent && (
                          <span style={textStyle(isCellHovered(r, c))}>
                            {cell.title}
                          </span>
                        )}
                      </div>
                    );
                  })}
                </div>
              </React.Fragment>
            ))}

            {/* Bottom axis label */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 6,
              }}
            >
              <span style={labelStyle(THEME.verticalAxisColor)}>AI Instapniveau</span>
            </div>
          </div>


        </div>

       
      </div>
    </div>
  );
}
